import axios from 'axios'
import { GridStack } from 'component'
import { action, payload } from 'ts-action'

import { generateQueryParams } from './store.helper'
import { ThunkAction } from './store.model'
import { getActualPage, getEndpoint, getFilters, getLimit, getSort } from './store.selector'

import { enviromentHelpers } from '@/helper'
import { datatableTypes } from '@/typings'

const prefix = 'datatable'

export const getDataStart = action(`${prefix}/GET-DATA--START`)
export const getDataSuccess = action(`${prefix}/GET-DATA--SUCCESS`, payload<datatableTypes.DatatablePayload>())
export const getDataError = action(`${prefix}/GET-DATA--ERROR`)

export const updateEndpoint = action(`${prefix}/UPDATE-ENDPOINT`, payload<{ endpoint: string }>())
export const updateSort = action(`${prefix}/UPDATE-SORT`, payload<{ dataKey: string }>())
export const updateLimit = action(`${prefix}/UPDATE-LIMIT`, payload<{ limit: number }>())
export const updatePage = action(`${prefix}/UPDATE-PAGE`, payload<{ page: number }>())
export const updateShowFilter = action(`${prefix}/UPDATE-SHOW-FILTER`, payload<{ showFilter: boolean }>())
export const updateFilter = action(
	`${prefix}/UPDATE-FILTER`,
	payload<{ col: string; filter: datatableTypes.DatatableFilter; value: any }>(),
)
export const resetFilter = action(`${prefix}/RESET-FILTER`)

export const getData =
	(props?: datatableTypes.DatatableGetDataProps): ThunkAction =>
	async (dispatch, getState) => {
		if (enviromentHelpers.isPDF()) {
			return
		}

		const state = getState()
		const params = generateQueryParams({
			...props,
			limit: getLimit(state),
			page: getActualPage(state),
			sort: getSort(state),
			filters: getFilters(state),
		})

		dispatch(getDataStart())
		try {
			const res = await axios.get(getEndpoint(state) + (params.length > 1 ? params : ''))
			dispatch(getDataSuccess(res.data))
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e)
			dispatch(getDataError())
		}
		GridStack.resizeToContent()
	}
